import React, { useEffect, useState } from "react";
import pdf from "../../Assets/svg/pdf-logo.svg";
import cross from "../../Assets/svg/cross.svg";
import Input from "./Input";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useSelector } from "react-redux";
import { api } from "../../Services";
import ModalComponent from "./Modal";
import GradientLoader from "./Loader";
import PDFViewer from "./PDFViewer";

function StaticItem(props) {
  const [show, setShow] = useState(true);
  const tokenData = useSelector((state) => state.tokens.tokens);
  const [uploading, setLoading] = useState(false);
  const [docData, setDocData] = useState("");
  const [isModal, showModal] = useState(false);
const [isPan, setPan] = useState('');
  function maskValue(value) {
    return (
      value?.slice(0, 3) +
      "*".repeat(value?.length - (value?.length > 6 ? 6 : value?.length)) +
      value?.slice(-3)
    );
  }
  const getPDF = async () => {
    // showModal(true)

    try {
      const docs1 = await api.getPDFData(tokenData.token, props.doc.id);
      return docs1;
    } catch (err) {
      // setLoading(false);
      // alert("Sorry! Something went wrong, Please try again.");
      // setErr({ showErr: true, errText: err.message });
    }
  };
  const viewPDF = async () => {
    // setLoading(true);

    try {
      const docs1 = await getPDF();
      console.log("base 64", docs1);
      // if (docs1.statusCode == 200) {
      // setLoading(false);
      if (docs1?.data?.resource_data[0]?.documentData) {
        setDocData(docs1.data.resource_data[0]);
        showModal(true);
      }
      // } else {
      //   setLoading(false);
      // }
    } catch (err) {
      // setLoading(false);
      console.log("err", err);

      // alert("Sorry! Something went wrong, Please try again.");
      // setErr({ showErr: true, errText: err.message });
    }
  };
  const submitPan = async () => {
    try {
      let panInfo = { panNumber: props?.value, name: props?.name || '', dob: props?.dob|| '' };

      let res = await await api.verifyPan(panInfo, tokenData.token);
      // let pL = { ...panList };

      return res;
    } catch (error) {
      console.error("Error Validating PAN:", error);
    }
  };

  const verifyPan = async () => {
    try {
      // setUploading(true);
      let res = await await submitPan();
      // let pL = { ...panList };
      if (res?.data?.panStatusCode === "E") {


        setPan(true)
      }
    } catch (error) {
      // setUploading(false);

      console.error("Error Validating PAN:", error);
    } finally {
      // setUploading(false);
console.log('pan finally')
      // return type;
    }
  };
  useEffect(() => {
    if(props.dob && props.name){
      verifyPan()
    }
  }, []);
  console.log("props.link", docData);
  return (
    <div className="static-item">
      <div className="item-title set-title">
        {props.title}
        {tokenData.applicationStatus === "Registered" && (!props.value ||(props?.title==="PAN" && !isPan) ) &&
          !props.title?.toLowerCase()?.includes("disability") && (
            <p className="error-msg">Required</p>
          )}
      </div>
      {props.type === "doc" && props.value ? (
        <div className="doc-upload doc-upload-section">
          <div className="doc-left">
            <div className="icon">
              <img src={pdf} alt="upload" />

              <div className="upload-text">
                <div className="upload-top-text">{props.value}</div>
                <div className="upload-btm-text">
                  <span>{`${props?.size || "800"}kb`} </span>
                </div>
              </div>
            </div>
          </div>
          {props.isEditable && (
            <div className="plus-icon upload-top-text">
              <img src={cross} alt="plus" />
              <input
                type="file"
                accept=".pdf"
                onChange={(e) => props.onDelete(e.target.files[0])}
              />
              {/* <img src={props.value ? cross : plus} alt="plus" /> */}
            </div>
          )}
          <div
            className="plus-icon upload-top-text"
            // onClick={() => props?.value && props?.onChange(null)}
          >
            <div onClick={() => viewPDF()}>view</div>
            {/* <img src={props.value ? cross : plus} alt="plus" /> */}
          </div>
        </div>
      ) : (
        <div className="static-item-div">
          <div className="item-value">
            {props.mask && show ? maskValue(props?.value) : props?.value}{" "}
          </div>
          {props.value && (
            <div
              className="item-value"
              onClick={() => setShow((prev) => !prev)}
            >
              {props.mask ? show ? <VisibilityOff /> : <Visibility /> : null}
            </div>
          )}
        </div>
      )}
      <ModalComponent
        className={"pdf-view-model"}
        show={isModal}
        handleClose={() => showModal(false)}
        // title={""}
        // content={""}
        noCross={false}
        // countDown={ModalData.countDown}
      >
        <PDFViewer docData={docData} />
      </ModalComponent>
      <ModalComponent
        className={"loader-model"}
        show={uploading}
        // handleClose={() => CancelData()}
        // title={ModalData.title}
        // content={ModalData.desc}
      >
        <GradientLoader />
      </ModalComponent>
    </div>
  );
}

export default StaticItem;
